import React from 'react';
import { useSyncExecution } from '@hooks/useSyncExecution';

export interface ILoading {
    isLoading: boolean;
    start: () => void;
    stop: () => void;    
}

export default function useLoading (initialValue: boolean = false) : ILoading {
    const _m = React.useRef(false);
    const syncExecution = useSyncExecution(initialValue);

    const [isLoading, setLoading] = React.useState(initialValue);

    const start = React.useCallback(() => {
        syncExecution.lock();
        if (_m.current) {
            setLoading(true);
        }
    }, [syncExecution]);

    const stop = React.useCallback(() => {
        syncExecution.free();
        if (_m.current) {
            setLoading(false);
        }
    }, [syncExecution]);

    React.useEffect(() => {
        _m.current = true;

        return () => {
            _m.current = false;
        }
    })

    return {
        isLoading: isLoading && !syncExecution.canExecute(),
        start, 
        stop
    }
}
